import type { FlowChildNode } from '../../../edit/flowGraph';
import { shownDefinitionName } from './shownDefinitionName';
import { shownDescription } from './shownDescription';

// The title row plus the node's padding and border.
const TITLE_HEIGHT = 37;
// One 0.75rem line under the title at the theme's 1.49 line height.
const LINE_HEIGHT = 18;
// The source handles stack down the right edge, the first one below the title.
const HANDLES_TOP = 28;
const HANDLE_HEIGHT = 27;

/**
 * The pixel height of a flow node on the canvas: enough for its text lines and for its source handles.
 *
 * `StandardNode` draws a node at this height and the layouts reserve it, so both must take it from here: text that does
 * not fit is drawn past the bottom of the box, over whatever the layout placed below it.
 */
export const flowNodeHeight = (node: Pick<FlowChildNode, 'data' | 'handles' | 'node_definition_name' | 'name' | 'description'>): number => {
  const handles = (node.data?.handles || node.handles || []).length;
  // The "ID:" line, then the definition name under a label, then the description.
  const textLines = 1 + (shownDefinitionName(node, node.data?.label) ? 1 : 0) + (shownDescription(node) ? 1 : 0);
  return Math.max(TITLE_HEIGHT + textLines * LINE_HEIGHT, HANDLES_TOP + handles * HANDLE_HEIGHT);
};
